export const CHANGE_PROVIDER_EMAIL_PASSWORD = 'opnjhaJZBLo4';
